import React from 'react';
import { useTranslation } from 'react-i18next';
import { UnderlineButton, Flex } from '@tq/ui-components';
import { useRecoilValue } from 'recoil';

import { ActionMenuButton } from 'components';
import { useNavigate, useNavigation, useResetSearchState } from 'hooks';
import { useAppBarMenuOptions } from '../../hooks';
import { isAdminOrConsulteeState } from 'store';

export type TQAppBarMenuProps = {
  location: string;
};

export const TQAppBarMenu: React.FC<TQAppBarMenuProps> = ({ location }) => {
  const { t } = useTranslation('app_bar');
  const { navigateToDashboard, navigateToReports } = useNavigate();
  const { isReportsPage, isConsultationPage } = useNavigation(location);
  const options = useAppBarMenuOptions();
  const resetSearch = useResetSearchState();

  const isAdminOrConsultee = useRecoilValue(isAdminOrConsulteeState);

  const goToDashboard = () => {
    resetSearch();
    navigateToDashboard();
  };

  return (
    <Flex gridGap={2} alignItems='center'>
      {isAdminOrConsultee && (
        <>
          <UnderlineButton
            color='white'
            isActive={isConsultationPage}
            size='sm'
            fontSize='md'
            active
            onClick={goToDashboard}
          >
            {t('consultations_button', 'Consultations')}
          </UnderlineButton>
          <UnderlineButton
            color='white'
            isActive={isReportsPage}
            size='sm'
            fontSize='md'
            onClick={navigateToReports}
          >
            {t('reports_button', 'Reports')}
          </UnderlineButton>{' '}
        </>
      )}
      <ActionMenuButton
        label={t('manage_account', 'Manage account')}
        options={options}
        small
        darkContrast
      />
    </Flex>
  );
};
